import type {
  CreateTransactionRequest,
  PaginationMeta,
  TransactionListQuery,
  TransactionResponse,
  UpdateTransactionRequest,
} from '@cosvision/shared';
import { request, requestNoContent, requestPaginated } from '../api.js';

/**
 * Build a query-string object from the partial TransactionListQuery, omitting
 * empty / undefined keys so we never send `?fundId=&direction=` style noise.
 */
function compactParams(query: Partial<TransactionListQuery>): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  for (const [k, v] of Object.entries(query)) {
    if (v === undefined || v === null) continue;
    if (typeof v === 'string' && v.length === 0) continue;
    out[k] = v;
  }
  return out;
}

export function listTransactions(
  query: Partial<TransactionListQuery> = {},
): Promise<{ data: TransactionResponse[]; meta: PaginationMeta }> {
  return requestPaginated<TransactionResponse>('get', '/transactions', undefined, {
    params: compactParams(query),
  });
}

export function getTransactionById(id: string): Promise<TransactionResponse> {
  return request<TransactionResponse>('get', `/transactions/${id}`);
}

export function createTransaction(input: CreateTransactionRequest): Promise<TransactionResponse> {
  return request<TransactionResponse>('post', '/transactions', input);
}

export function updateTransaction(
  id: string,
  input: UpdateTransactionRequest,
): Promise<TransactionResponse> {
  return request<TransactionResponse>('patch', `/transactions/${id}`, input);
}

export function deleteTransaction(id: string): Promise<void> {
  return requestNoContent('delete', `/transactions/${id}`);
}
